var React = require('react');

function StarterInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_8954_121081)","key":0},React.createElement("path",{"d":"M18.9775 32.5L11.681 25.2035L18.5521 13.9479L7.29652 20.819L0 13.5225L32 0.5L18.9775 32.5Z"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_8954_121081"},React.createElement("rect",{"width":"32","height":"32","fill":"white","transform":"translate(0 0.5)"})))]);
}

StarterInline.defaultProps = {"width":"32","height":"33","viewBox":"0 0 32 33","fill":"none"};

module.exports = StarterInline;

StarterInline.default = StarterInline;
